import { ReactNode } from 'react';
import { PlaceholderContext } from './PlaceholderContext';

interface Props {
  active?: boolean;
  children: ReactNode;
}

export function Placeholder({ active = true, children }: Props) {
  return (
    <PlaceholderContext.Provider value={active}>
      {children}
    </PlaceholderContext.Provider>
  );
}
